export default "__VITE_ASSET__DR0enfQs__"